import { lazy } from 'react';
export var CodeConfirmPage = lazy(function () { return import('./code-confirm-page.component'); });
export var CompanyRegistrationPage = lazy(function () { return import('./company-registration-page'); });
